var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "price-select" },
      [
        _vm._t("default", function () {
          return [
            _c("div", { staticClass: "price-select__title" }, [
              _vm._v("MyPrice"),
            ]),
          ]
        }),
        _vm._v(" "),
        _c("div", { staticClass: "price-select__blocks" }, [
          _c("label", { staticClass: "price-select__label" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.pmin,
                  expression: "pmin",
                },
              ],
              staticClass: "price-select__input",
              class: { red: _setup.error_min() },
              attrs: { type: "text", placeholder: _setup.props.list[0] },
              domProps: { value: _setup.pmin },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _setup.pmin = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "price-select__text" }, [
              _vm._v("\n                    от\n                "),
            ]),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "price-select__label" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.pmax,
                  expression: "pmax",
                },
              ],
              staticClass: "price-select__input",
              class: { red: _setup.error_max() },
              attrs: { type: "text", placeholder: _setup.props.list[1] },
              domProps: { value: _setup.pmax },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _setup.pmax = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "price-select__text" }, [
              _vm._v("\n                    до\n                "),
            ]),
          ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }